module.exports = __webpack_public_path__ + "img/image161.9b098922.jpg";